import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  socketServer: 'https://backend.dev.johnstonsconnected.com',
  graphQLServer: 'https://backend.dev.johnstonsconnected.com/graphql',
  firebaseConfig: {
    apiKey: 'AIzaSyCQAuEbKXJCl2H2dBV0sSeGpM015u3sFhM',
    authDomain: 'johnston-s-connected-dev.firebaseapp.com',
    projectId: 'johnston-s-connected-dev',
    storageBucket: 'johnston-s-connected-dev.appspot.com',
    messagingSenderId: '443659798769',
    appId: '1:443659798769:web:f6fc893773e498c3d14150',
    measurementId: 'G-YPGHPD6DP1',
    vapidKey:
      'BGFPGEcpKNh3fwhwYEbuKSZiAAZLD9Adn6aDmHv3SyL9MNkXwbKsIUOHgxq-w1WIzUM8hdToZJA8Qg9Ej6q5s_Q',
  },
  links: {
    termsOfService:
      'https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Terms+of+Use.pdf',
    privacyPolicy:
      "https://s3.ca-central-1.amazonaws.com/johnstonsconnected.com/legal/Privacy+Policy-+Johnston's+Connected.pdf",
    androidApp:
      'https://play.google.com/store/apps/details?id=com.johnstonsgrain.connected',
    iosApp: 'https://apps.apple.com/us/app/johnstons-connected/id6744170820',
    privateIosApp:
      'https://apps.apple.com/us/app/johnstons-connected/id6744170820',
  },
  wordpress: {
    endpoint: 'https://johnstonsgrain.com/wp-json/wp/v2',
  },
};
